import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class SimpleOutput extends DesigntimeComponent {
    static staticName = "Simple output (Testing)";
    static staticId = "simpleOutput";

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            text: new LiquidString("Default text", `${this.id}text`),
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var view = $("<div></div>");

        view.append(this.values.text.getTag("h3"));

        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));

        return view;

    }

    importModel(model) {
        for (var param in model.params) {
            for (var i in this.values) {
                if (this.values[i] instanceof LiquidString)
                    this.values[i].replace(`{{${param}}}`, `{{${model.params[param].key}}}`);
            }
        }
        delete model.params.parameter1;

        super.importModel(model);
    }
}

export { SimpleOutput }
